import { render } from "./CompaniesSlider.vue?vue&type=template&id=5f91bf60&scoped=true"
import script from "./CompaniesSlider.vue?vue&type=script&lang=js"
export * from "./CompaniesSlider.vue?vue&type=script&lang=js"

import "./CompaniesSlider.vue?vue&type=style&index=0&id=5f91bf60&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f91bf60"]])

export default __exports__